import React from 'react';
import { Spinner } from 'react-bootstrap';
const LoadingSpinner = (props) => {
    return (<div className={props?.className || "text-center my-2"}><Spinner animation="border" variant="primary" {...props} /></div>)
}
export default LoadingSpinner;